import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/global.css';

import Navbar from './components/Navbar';
import MarketingVisitTracker from './components/MarketingVisitTracker';
import CartTracker from './components/CartTracker';
import HomePage from './pages/HomePage';

// Lazy load altre pagine
const CatalogoPage = React.lazy(() => import('./pages/CatalogoPage'));
const ProductPage = React.lazy(() => import('./pages/ProductPage'));
const CartPage = React.lazy(() => import('./pages/CartPage'));
const CheckoutPage = React.lazy(() => import('./pages/CheckoutPage'));
const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const RegisterPage = React.lazy(() => import('./pages/RegisterPage'));
const ProfilePage = React.lazy(() => import('./pages/ProfilePage'));
const CellarPage = React.lazy(() => import('./pages/CellarPage'));
const ChangePasswordPage = React.lazy(() => import('./pages/ChangePasswordPage'));
const TrackingPage = React.lazy(() => import('./pages/TrackingPage'));
const LegalInfoPage = React.lazy(() => import('./pages/LegalInfoPage'));
const CancelRequestPage = React.lazy(() => import('./pages/CancelRequestPage'));
const AdminDashboard = React.lazy(() => import('./pages/admin/Dashboard'));
const CRMDashboard = React.lazy(() => import('./pages/crm/Dashboard'));

function App() {
  return (
    <Router>
      <MarketingVisitTracker />
      <CartTracker />
      <div className="App">
        <Navbar />
        <React.Suspense fallback={
          <div className="flex-center" style={{ minHeight: '80vh' }}>
            <div className="spinner"></div>
          </div>
        }>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalogo" element={<CatalogoPage />} />
            <Route path="/prodotto/:id" element={<ProductPage />} />
            <Route path="/carrello" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/success" element={<CheckoutPage />} />
            <Route path="/checkout/cancel" element={<CheckoutPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/cambio-password" element={<ChangePasswordPage />} />
            <Route path="/profilo" element={<ProfilePage />} />
            <Route path="/cantina" element={<CellarPage />} />
            <Route path="/tracking" element={<TrackingPage />} />
            <Route path="/info-legali" element={<LegalInfoPage />} />
            <Route path="/richiesta-annullamento/:orderId" element={<CancelRequestPage />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/crm/*" element={<CRMDashboard />} />
          </Routes>
        </React.Suspense>
        <ToastContainer
          position="bottom-right"
          theme="dark"
          autoClose={3000}
        />
      </div>
    </Router>
  );
}

export default App;
